// Generated for @nava/participant-copy: Clair's default texts in German. Edit the texts here; the
// participant app's locale files are not read at runtime.
/** Clair's default texts in German. The texts that changed for Clair are translated without native review yet. */
export const PARTICIPANT_COPY_DE = {
    'landing.changeLanguage': 'Sprache ändern',
    'common.language': 'Sprache',
    // New for Clair, translated without native review yet.
    'common.talkInLanguages': 'Du kannst mit Clair in mehr als 80 Sprachen sprechen.',
    'common.seeLanguages': 'Alle anzeigen',
    'footer.poweredBy': 'Bereitgestellt von',
    'landing.heading': 'Du wurdest zu einem kurzen Gespräch eingeladen.',
    'landing.intro': '{company} möchte gern hören, wie es bei dir läuft. Du sprichst mit Clair, einer KI-Assistentin, wann es dir passt.',
    'landing.continue': 'Weiter',
    'preflight.title': 'Wir brauchen nur ein paar Dinge',
    'preflight.checkInSubtitle': 'Geh die Checkliste unten durch, um das Gespräch zu starten.',
    'preflight.actions.expandItem': '{{item}} erweitern',
    'preflight.microphone.title': 'Mikrofonzugriff',
    'preflight.microphone.checkInPrivacy': 'Deine Stimme wird für das Gespräch mit Clair, einer KI-Assistentin, verwendet. Das Gespräch wird aufgezeichnet, transkribiert und an {company} weitergegeben. Alle Daten werden verschlüsselt und sicher gespeichert.',
    'preflight.microphone.readMore': 'Mehr lesen',
    'preflight.microphone.grantAccess': 'Zugriff erlauben',
    'preflight.microphone.indicatorAction': 'Mikrofonzugriff erlauben',
    'preflight.microphone.accessGranted': 'Zugriff gewährt',
    'preflight.microphone.errorHelper': 'Überprüfe deine Browsereinstellungen und versuche es erneut.',
    'preflight.microphone.browserNotSupported': 'Dein Browser unterstützt keine Audioaufnahme. Bitte verwende Chrome, Firefox oder Safari.',
    'preflight.terms.title': 'Datenschutz & Einwilligung',
    'preflight.terms.checkInPrivacy': 'Dieses Gespräch führt Clair, eine KI-Assistentin, im Auftrag von {company}. Deine Antworten werden an {company} weitergegeben und nie für Werbung genutzt. Du kannst jederzeit aufhören.',
    'preflight.terms.readMore': 'Mehr lesen',
    'preflight.terms.accept': 'Ja, ich akzeptiere',
    'preflight.terms.indicatorAction': 'Datenschutz und Einwilligung akzeptieren',
    'preflight.terms.accepted': 'Akzeptiert',
    'preflight.terms.rememberConsent': 'Meine Einwilligung 30 Tage lang merken',
    'preflight.terms.rememberConsentCallTooltip': 'Die Einwilligung wird nur für dieses Gespräch in diesem Browser 30 Tage lang gespeichert.',
    'quickStart.agree': 'Zustimmen',
    'quickStart.back': 'Zurück',
    'quickStart.cancel': 'Abbrechen',
    'preflight.startCheckIn': 'Gespräch starten',
    'preflight.preparingCheckIn': 'Das Gespräch wird vorbereitet...',
    'preflight.preparingCheckInDelayedTitle': 'Das Gespräch wird vorbereitet.',
    'preflight.preparingCheckInDelayedSubtitle': 'Wir arbeiten noch daran, bitte warte.',
    'preflight.preparingCheckInLongSubtitleLineOne': 'Das dauert länger als erwartet.',
    'preflight.preparingCheckInLongSubtitleLineTwo': 'Bitte hab Geduld.',
    'preflight.checkInPreparationFailedTitle': 'Das Gespräch konnte nicht vorbereitet werden',
    'preflight.checkInPreparationFailedMessage': 'Einige Dateien für das Gespräch konnten nicht geladen werden. Prüfe deine Verbindung und versuche es erneut.',
    'preflight.retryPreparation': 'Try again',
    'interview.status.connecting': 'Verbinden',
    'interview.status.speaking': 'Spricht',
    'interview.status.listening': 'Hört zu',
    'interview.status.thinking': 'Denkt nach',
    'interview.question': 'Frage {{current}} von {{total}}',
    'interview.mainQuestion': 'Hauptfrage {{current}} von {{total}}',
    'interview.recording': 'Deine Antwort wird aufgezeichnet...',
    'interview.endInterview': 'Gespräch beenden',
    'interview.muteTooltip': 'Mikrofon stumm schalten',
    'interview.unmuteTooltip': 'Mikrofon einschalten',
    'interview.pauseTooltip': 'Pause machen',
    'interview.resumeTooltip': 'Gespräch fortsetzen',
    'interview.subtitleTooltip.show': 'Untertitel anzeigen (CC)',
    'interview.subtitleTooltip.hide': 'Untertitel ausblenden (CC)',
    'interview.toggleChat': 'Stattdessen tippen',
    'interview.toggleVoice': 'Stattdessen sprechen',
    'interview.chatTooltip.type': 'Antwort stattdessen tippen',
    'interview.chatTooltip.speak': 'Antwort stattdessen sprechen',
    'interview.chatTooltip.unavailable': 'Verfügbar, sobald verbunden',
    'interview.chatDiscoveryHint': 'Kannst du nicht sprechen? Tippe stattdessen',
    'interview.chatPlaceholder': 'Schreiben Sie Ihre Nachricht...',
    'interview.sendMessage': 'Senden',
    'interview.chat.warmHeader': 'Lass dir Zeit, ich warte, während du schreibst',
    'interview.chat.newlineHint': 'Shift + Enter für eine neue Zeile',
    'interview.chat.aiVoiceOn': 'Stimme ein',
    'interview.chat.aiVoiceOff': 'Stimme aus',
    'interview.chat.backToVoice': 'Zurück zur Stimme',
    'interview.audio.controls': 'Audioeinstellungen',
    'interview.audio.callVolume': 'Gesprächslautstärke',
    'interview.audio.muteSpeaker': 'Lautsprecher stummschalten',
    'interview.audio.unmuteSpeaker': 'Lautsprecher einschalten',
    'interview.audio.microphone': 'Mikrofon',
    'interview.audio.speaker': 'Lautsprecher',
    'interview.audio.device': 'Audiogerät',
    'interview.audio.linkedRouting': 'Dein Telefon steuert Mikrofon und Lautsprecher gemeinsam.',
    'interview.audio.phoneSpeaker': 'Lautsprecher des Telefons',
    'interview.audio.phoneEarpiece': 'Hörmuschel des Telefons',
    'interview.audio.bluetoothHeadset': 'Bluetooth-Headset',
    'interview.audio.wiredHeadset': 'Kabel-Headset',
    'interview.audio.usbAudio': 'USB-Audio',
    'interview.audio.systemDefault': 'Systemstandard',
    'interview.audio.changeFailed': 'Das Audiogerät konnte nicht gewechselt werden.',
    'interview.networkQuality.excellent': 'Die Netzwerkqualität ist ausgezeichnet.',
    'interview.networkQuality.good': 'Die Netzwerkqualität ist gut.',
    'interview.networkQuality.poor': 'Die Netzwerkqualität ist schlecht.',
    'interview.networkQuality.bad': 'Die Netzwerkqualität ist sehr schlecht.',
    'interview.networkQuality.offline': 'Die Verbindung ist offline.',
    'interview.pauseModal.title': 'Gespräch pausiert',
    'interview.pauseModal.timeRemaining': 'Noch {{time}}',
    'interview.pauseModal.timeoutWarning': 'Wenn du pausiert bleibst, endet das Gespräch bald von selbst.',
    'interview.pauseModal.resume': 'Gespräch fortsetzen',
    'interview.pauseModal.end': 'Gespräch beenden',
    'interview.endConfirm.title': 'Das Gespräch beenden?',
    'interview.endConfirm.body': 'Sie können nach dem Beenden nicht zurückkehren. Ihre bisherigen Antworten werden gespeichert.',
    'interview.endConfirm.cancel': 'Gespräch fortsetzen',
    'interview.endConfirm.end': 'Gespräch beenden',
    'complete.checkInTitle': 'Danke für deine Zeit',
    'complete.checkInMessage': 'Deine Antworten gehen an das Team von {company}.',
    'studyClosed.checkInTitle': 'Dieses Gespräch ist geschlossen',
    'studyClosed.checkInMessage': 'Danke für dein Interesse, es nimmt keine Antworten mehr an.',
    'studyNotOpen.checkInTitle': 'Dieses Gespräch ist noch nicht geöffnet',
    'studyNotOpen.checkInMessage': 'Bitte probiere den Link später noch einmal.',
    'studyNotReady.checkInTitle': 'Dieses Gespräch ist fast bereit',
    'studyNotReady.checkInMessage': 'Bitte probiere den Link in ein paar Minuten noch einmal.',
    'participantLinkCompleted.checkInTitle': 'Du hast dieses Gespräch bereits geführt',
    'participantLinkCompleted.checkInMessage': 'Danke für deine Zeit, du musst nichts weiter tun.',
    'loading.interview': 'Das Gespräch wird geladen...',
    'browserHelp.title': 'Im Browser öffnen',
    'browserHelp.description': 'Der integrierte Browser dieser App kann den Mikrofonzugriff einschränken. Öffne den Link für ein besseres Erlebnis in {{browserOptions}}.',
    'browserHelp.namedDescription': 'Der integrierte Browser von {{app}} kann den Mikrofonzugriff einschränken. Öffne den Link für ein besseres Erlebnis in {{browserOptions}}.',
    'browserHelp.appleBrowsers': 'Safari oder Chrome',
    'browserHelp.windowsBrowsers': 'Microsoft Edge oder Chrome',
    'browserHelp.otherBrowsers': 'Chrome oder einem anderen Browser',
    'browserHelp.openSafari': 'In Safari öffnen',
    'browserHelp.copyLink': 'Link kopieren',
    'browserHelp.copied': 'Link kopiert. Füge ihn in deinen Browser ein.',
    'browserHelp.manualCopy': 'Automatisches Kopieren war nicht möglich. Markiere und kopiere den Link unten.',
    'browserHelp.copyInstructions': 'Kopiere den Link unten und füge ihn in einen anderen Browser ein. Du kannst auch im Menü der App nach einer Option suchen, um diese Seite in deinem Standardbrowser zu öffnen.',
    'browserHelp.linkLabel': 'Link zum Gespräch',
    'browserHelp.continueAnyway': 'Trotzdem fortfahren',
    'preflight.microphone.recovery.denied': 'Mikrofonzugriff verweigert.',
    'preflight.microphone.recovery.timedOut': 'Die Anfrage für den Mikrofonzugriff hat zu lange gedauert. Prüfe, ob dein Browser nach einer Berechtigung fragt, und versuche es erneut.',
    'preflight.microphone.recovery.notFound': 'Kein Mikrofon gefunden. Schließe ein Mikrofon an und versuche es erneut.',
    'preflight.microphone.recovery.notReadable': 'Dein Mikrofon konnte nicht geöffnet werden. Schließe andere Apps, die es verwenden, und versuche es erneut.',
    'preflight.microphone.recovery.failed': 'Wir konnten nicht auf dein Mikrofon zugreifen. Überprüfe es und versuche es erneut.',
    'preflight.microphone.recovery.retry': 'Erneut versuchen',
    'preflight.microphone.recovery.close': 'Schließen',
    'preflight.microphone.recovery.helpTitle': 'Mikrofonzugriff erlauben',
    'preflight.microphone.recovery.helpDescription': 'Der Mikrofonzugriff ist weiterhin blockiert. Dein Browser hat deine frühere Auswahl möglicherweise gespeichert und zeigt deshalb keine erneute Abfrage an.',
    'preflight.microphone.recovery.safariMacSettings': 'Wähle in der Safari-Menüleiste Safari > Einstellungen > Websites > Mikrofon. Suche diese Website in der Liste.',
    'preflight.microphone.recovery.chromiumSettings': 'Klicke links neben der Adressleiste auf das Symbol für die Website-Einstellungen und wähle Website-Einstellungen > Mikrofon.',
    'preflight.microphone.recovery.siteSettings': 'Öffne die Berechtigungen dieser Website über das Symbol oder Menü neben der Adressleiste oder über die Website-Einstellungen deines Browsers.',
    'preflight.microphone.recovery.allowMicrophone': 'Erlaube dieser Website den Mikrofonzugriff. Kehre dann hierher zurück und wähle „Erneut versuchen“. Lade diese Seite neu, wenn der Browser dich dazu auffordert.',
    'preflight.microphone.recovery.deviceSettings': 'Wenn der Zugriff bereits erlaubt ist, prüfe, ob dein Browser in den Geräteeinstellungen das Mikrofon verwenden darf.',
    'microphoneQuality.title': 'Mikrofonqualität',
    'microphoneQuality.instructions': 'Sprich für ein paar Sekunden, damit wir prüfen können, wie gut wir dich hören.',
    'microphoneQuality.recoveryMessage': 'Wir können dich nicht hören. Falls du gerade telefonierst, beende zuerst den Anruf. Schließe andere Apps, die dein Mikrofon verwenden, und versuche es erneut.',
    'microphoneQuality.poor': 'Schlecht',
    'microphoneQuality.almostThere': 'Fast da',
    'microphoneQuality.perfect': 'Perfekt!',
    'microphoneQuality.waiting': 'Warte auf Audio...',
    'microphoneQuality.from': 'Von',
    'microphoneQuality.defaultDevice': 'Standardmikrofon',
    'microphoneQuality.helpText': 'Bitte sprich lauter oder geh näher an dein Mikrofon',
    'microphoneQuality.done': 'Fertig',
    'startupRecovery.title': 'Das Gespräch konnte nicht starten',
    'startupRecovery.failed': 'Wir konnten keine Verbindung zum Gesprächsdienst herstellen. Bitte versuche es erneut.',
    'startupRecovery.timedOut': 'Der Verbindungsaufbau hat zu lange gedauert. Bitte versuche es erneut.',
    'startupRecovery.cancelled': 'Die Verbindung wurde abgebrochen. Du kannst es erneut versuchen, wenn du bereit bist.',
    'startupRecovery.microphone': 'Wir konnten nicht auf dein Mikrofon zugreifen. Prüfe die Berechtigungen und versuche es erneut.',
    'startupRecovery.delayed': 'Die Verbindung wird noch aufgebaut. Es dauert länger als üblich…',
    'startupRecovery.retry': 'Erneut versuchen',
    'startupRecovery.support': 'Support-Referenz',
    'startupRecovery.copy': 'Referenz kopieren',
    'startupRecovery.copied': 'Kopiert',
    'startupRecovery.checking': 'Verbindung wird geprüft…',
    'startupRecovery.unavailable': 'Nicht bestätigt',
    'startupRecovery.advice': 'Diese Prüfung testet nur die Erreichbarkeit. Du kannst trotzdem versuchen zu starten. Falls es nicht klappt, probiere einen anderen Browser oder ein anderes Netzwerk.',
    'startupRecovery.checkAgain': 'Verbindung erneut prüfen...',
    'connectionDetails.quality': 'Netzwerkqualität',
    'connectionDetails.excellent': 'Ausgezeichnet',
    'connectionDetails.good': 'Gut',
    'connectionDetails.poor': 'Schwach',
    'connectionDetails.bad': 'Schlecht',
    'connectionDetails.offline': 'Offline',
    'connectionDetails.notChecked': 'Nicht geprüft',
    'connectionDetails.lastChecked': 'Zuletzt geprüft',
    'connectionDetails.warning': 'Die Verbindung zu {{services}} konnte nicht bestätigt werden.',
    'connectionDetails.navaApi': 'Clair-API',
    'connectionDetails.interviewApi': 'Gesprächsdienst von Clair',
    'connectionDetails.ok': 'OK',
    'connectionDetails.refresh': 'Verbindungstest aktualisieren',
    'connectionDetails.success': 'Verbindungsprüfung erfolgreich.',
    'connection.error': 'Verbindungsfehler',
    'connection.errorDefault': 'Verbindung zum Gesprächsdienst fehlgeschlagen',
    'connection.retry': 'Erneut versuchen',
    'versionRefresh.message': 'Eine neue Version ist verfügbar. Aktualisieren Sie Ihren Browser, wenn es Ihnen passt.',
    'versionRefresh.action': 'Aktualisieren',
    'cookies.banner.title': 'Wir schätzen deine Privatsphäre',
    'cookies.banner.message': 'Wir verwenden Cookies, um dein Erlebnis zu optimieren, die Produktnutzung zu verstehen und relevantes Marketing zu unterstützen. Wähle <bold>“Alle akzeptieren”</bold>, um allen Cookies zuzustimmen, oder <bold>“Einstellungen verwalten”</bold>, um deine Einstellungen anzupassen.',
    'cookies.banner.privacyPolicy': 'Datenschutzerklärung',
    'cookies.banner.acceptAll': 'Alle akzeptieren',
    'cookies.banner.managePreferences': 'Einstellungen verwalten',
    'cookies.modal.title': 'Cookie-Einstellungen',
    'cookies.modal.description': 'Wenn du Clair besuchst, können wir mithilfe von Cookies und ähnlichen Technologien Daten über dich speichern oder abrufen. Notwendige Cookies sorgen dafür, dass die Website funktioniert. Optionale Einstellungen kannst du jederzeit ändern.',
    'cookies.modal.readMore': 'Mehr dazu in unserer',
    'cookies.modal.save': 'Speichern',
    'cookies.modal.close': 'Cookie-Einstellungen schließen',
    'cookies.modal.essential.title': 'Essenziell',
    'cookies.modal.essential.description': 'Erforderlich für die grundlegende Funktionalität der Website. Essenzielle Cookies können nicht deaktiviert werden.',
    'cookies.modal.analytics.title': 'Analyse',
    'cookies.modal.analytics.description': 'Hilft Clair zu verstehen, wie die Website funktioniert, wie Besucher sie nutzen und ob es technische Probleme geben könnte.',
    'invitation.subject': 'Ein kurzes Gespräch mit {company}',
    'invitation.greeting': 'Hallo {name},',
    'invitation.body': 'Wir möchten gern hören, wie es bei dir läuft.',
    'invitation.aiNotice': 'Du sprichst mit Clair, unserer KI-Assistentin. Den meisten Menschen fällt es leichter, gegenüber einer KI ehrlich zu sein als gegenüber einem Menschen, und du kannst es machen, wann es dir passt, bei der Arbeit oder zu Hause.',
    'invitation.button': 'Gespräch starten',
    'invitation.fallbackLink': 'Oder füge diesen Link in deinen Browser ein:',
    'invitation.footer': 'Du erhältst diese E-Mail, weil du Kundin oder Kunde von {company} bist. Das Gespräch führt Clair, eine KI-Assistentin, in deren Auftrag.',
    'invitation.optOut': 'Diese E-Mails nicht mehr senden',
    'sms.invite': '{company} lädt dich zu einem kurzen Gespräch ein:',
    'sms.stop': 'SMS abbestellen:',
};
//# sourceMappingURL=de.js.map